import { Button } from "@/shared/ui"

interface IProps {
  name: string,
  testId?: string,
  addressLine1?: string,
  addressLine2?: string,
  onUpdate?: () => void;
}

export const Card = ({
  name,
  testId = 'base-prescription-medication-form-card',
  onUpdate,
  addressLine1,
  addressLine2
}: IProps) => {
  return (
    <div data-testid={testId} className="flex-column w-full">
      <div className='flex items-center justify-between'>
        <span data-testid={`${testId}-name`} className='text-lg lg:text-xl font-atkinsonHyperlegible'>{name}</span>
        {
          onUpdate && <Button variant='text' onClick={onUpdate} className="" testId="button-card-edit">
            Edit
          </Button>
        }
      </div>
      {addressLine1 && <span data-testid={`${testId}-address-line-1`}>
        {addressLine1}
      </span>}
      {addressLine2 && <span data-testid={`${testId}-address-line-2`}>
        &nbsp;{addressLine2}
      </span>}
    </div>
  )
}